import styled, { css } from 'styled-components'

export const GlobalVariables = css<{ $colorMode?: 'light' | 'dark' }>`
  // COLORS
  // 🟦
  --brandblue-main: #202346;
  --brandblue-bright-1: #474a66;
  --brandblue-bright-2: #6f7187;
  --brandblue-bright-3: #9698a8;
  --brandblue-bright-4: #c8c8d1;
  --brandblue-bright-5: #f0f0f2;

  --blue-dark-2: #1b475e;
  --blue-dark-1: #296a8d;
  --blue-main: #378ebd;
  --blue-bright-1: #69aacd;
  --blue-bright-2: #9bc6de;
  --blue-bright-3: #cde2ee;

  // 🟨
  --yellow-main: #ffe462;

  // 🟪
  --petrol-dark-2: #16514f;
  --petrol-dark-1: #217977;
  --petrol-main: #2ca29f;
  --petrol-bright-1: #60b9b7;
  --petrol-bright-2: #95d0cf;
  --petrol-bright-3: #cae7e7;

  // 🟩
  --green-dark-2: #234930;
  --green-dark-1: #356d48;
  --green-main: #479260;
  --green-bright-1: #75ad87;
  --green-bright-2: #a3c8af;
  --green-bright-3: #d1e3d7;

  // 🟪
  --purple-dark-2: #512a4f;
  --purple-dark-1: #7a3f77;
  --purple-main: #a757a3;
  --purple-bright-1: #ba7fb7;
  --purple-bright-2: #d1aacf;
  --purple-bright-3: #e8d4e7;

  // 🟧
  --orange-dark-2: #703600;
  --orange-dark-1: #964800;
  --orange-main: #e16d00;
  --orange-bright-1: #e78d38;
  --orange-bright-2: #f1be8d;
  --orange-bright-3: #f8dec6;

  // 🟥
  --red-dark-2: #691a1f;
  --red-dark-1: #9e272f;
  --red-main: #d3343f;
  --red-bright-1: #de666f;
  --red-bright-2: #e9999f;
  --red-bright-3: #f4cccf;

  // 🟫
  --beige-dark-2: #575247;
  --beige-dark-1: #7b7768;
  --beige-main: #a09c8a;
  --beige-bright-1: #dcd8c9;
  --beige-bright-2: #efece0;
  --beige-bright-3: #f8f7f4;

  // ⬜️
  --gray-1: #121212;
  --gray-2: #555;
  --gray-3: #7d7d7d;
  --gray-4: #d4d4d4;
  --gray-5: #e9e9e9;
  --gray-6: #f4f4f4;

  --tenant-bz: #800000;
  --tenant-bol: #800000;
  --tenant-lt: #800000;
  --tenant-tt: #800000;
  --tenant-zrz: #2c3890;
  --tenant-tdg: #2c3890;
  --tenant-zul: #2c3890;
  --tenant-l: #2c3890;
  --tenant-baz: #d9010e;
  --tenant-24h: #d9010e;
  --tenant-bnd: #0085ab;
  --tenant-ta: #0085ab;

  
  --site-background: #fff;
  --panel-color: var(--gray-6);
  ${({ $colorMode }) =>
    $colorMode === 'dark'
      ? css`
          // 🌚 all Dark Mode variables
          --tenant-bz: #9c3838;
          --tenant-bol: #9c3838;
          --tenant-lt: #9c3838;
          --tenant-tt: #9c3838;
          --tenant-zrz: #5a64a8;
          --tenant-tdg: #5a64a8;
          --tenant-zul: #5a64a8;
          --tenant-l: #5a64a8;

          
          --site-background: var(--gray-1);
          --panel-color: var(--gray-2);
        `
      : ''}

  // FONTS
  --font-plex: "IBM Plex Sans","Helvetica",Arial,Verdana,Helvetica,sans-serif;
  --font-noto: 'Noto Serif', 'Times New Roman', Helvetica, serif;
  color: var(--text-color);
`
